import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import ErrorPage from '../views/ErrorPage.vue';
import PdfPage from '../views/PdfPage.vue';
import TextPage from '../views/TextPage.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: '/pdf',
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: PdfPage,
  },
  {
    path: '/text',
    name: 'text',
    component: TextPage,
  },
  {
    path: '/error',
    name: 'error',
    component: ErrorPage,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/home',
  routes,
});

export default router;
